import { Button } from 'antd';
import { get } from 'lodash';
import FundingUnavailable from 'src/_shared/components/funding-unavailable/FundingUnavailableComponent.jsx';
import { ONBOARDING_SCREENS } from '../constants';
import {
	buttonContainerStyle,
	buttonStyle,
	containerStyle,
	noteStyle,
	subtitleStyle,
	textBodyStyle,
	titleContainerStyle,
	titleStyle,
} from './onboardingStyles.js';

function GiftCardPayouts(props) {
	const { company, completeOnboardingPage, uncompleteOnboardingPage, navToScreen } =
		props;
	const partnerHost = get(company, 'partnerHost');

	const next = () => {
		completeOnboardingPage(ONBOARDING_SCREENS.GIFT_CARD_PAYOUTS, {
			status: 'skipped',
		});
		navToScreen(ONBOARDING_SCREENS.BONUS_REPORTING);
	};

	const back = () => {
		uncompleteOnboardingPage(ONBOARDING_SCREENS.GIFT_CARD_PAYOUTS);
		navToScreen(ONBOARDING_SCREENS.HOW_TO_PAY);
	};

	return (
		<div className={containerStyle}>
			<div className={titleContainerStyle(partnerHost)}>
				<h1 className={titleStyle}>Fund Your Gift Card Account</h1>
				<div
					className={textBodyStyle}
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<div className={subtitleStyle} style={{ marginBottom: 20 }}>
						Adding funds to your account will allow your employees to start
						cashing in their earned bonuses when they are eligible.
					</div>
					<div
						style={{
							marginTop: 30,
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						<FundingUnavailable style={{ maxWidth: 480 }} />
					</div>

					<div
						className={noteStyle}
						style={{
							width: '70%',
							textAlign: 'center',
							marginTop: 50,
							alignSelf: 'center',
						}}
					>
						NOTE: If you do not add any store funds, your employees will not be
						able to cash in their earned points for rewards.
					</div>
					<div className={buttonContainerStyle} style={{ marginTop: 30 }}>
						<Button
							type="primary"
							shape="round"
							size="large"
							className={buttonStyle}
							style={{ marginRight: 30 }}
							onClick={back}
						>
							Back
						</Button>
						<Button
							type="primary"
							shape="round"
							size="large"
							className={buttonStyle}
							onClick={next}
						>
							Next
						</Button>
					</div>
					<div style={{ height: 40 }} />
				</div>
			</div>
		</div>
	);
}

export default GiftCardPayouts;
